import { css } from '@emotion/css';
import { m, smallMobileMediaQuery } from '@snapchat/snap-design-system-marketing';

export const contentContainerCss = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: ${m('--spacing-xxxl')};

  ${smallMobileMediaQuery} {
    margin-bottom: ${m('--spacing-xl')};
  }
`;
